<template>
    <div class="flex flex-col my-auto">
      <div class="flex mx-auto mb-6">
        <div @click="cardClick('sub-offer-one')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
          <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">EMOTIONAL <br>BONDING</h4>
        </div>
        <div @click="cardClick('sub-offer-two')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
          <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">PROFITABILITY</h4>
        </div>
        <div @click="cardClick('sub-offer-three')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
          <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">COMPETITIVE <br>POWER</h4>
        </div>
      </div>

      <div class="flex m-auto">
        <div @click="cardClick('sub-offer-four')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
          <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">ACQUISITION</h4>
        </div>
        <div @click="cardClick('sub-offer-five')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
          <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">INTRINSIC <br>AI</h4>
        </div>
        <div @click="cardClick('sub-offer-six')" class="circles flex rounded-full bg-black mr-10 cursor-pointer">
          <h4 class="font-bold m-auto text-center text-xl 2xl:text-2xl leading-tight text-white">PERFECT <br>FOR <br>LOBBYING </h4>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "OfferIndex",
  methods:{
    cardClick(cardName){
      Event.$emit('clickedCard', cardName);
    }
  }
}
</script>

<style lang="css" scoped>

.circles{
  width: 13rem;
  height: 13rem;
}

@media (min-width: 1024px){

  .circles{
    width: 11rem;
    height: 11rem;
  }

}

@media (min-width: 1280px){

  .circles{
    width: 12rem;
    height: 12rem;
  }

}

@media (min-width: 1367px){

  .circles{
    width: 13rem;
    height: 13rem;
  }

}

@media (min-width: 1500px){

  .circles{
    width: 12rem;
    height: 12rem;
  }

}

@media (min-width: 1550px){

  .circles{
    width: 13rem;
    height: 13rem;
  }

}

@media (min-width: 2000px){

  .circles{
    width: 18rem;
    height: 18rem;
  }

}
</style>
